export default __webpack_public_path__ + "static/maskid-709b52ba8ea30a03e6d8fdbb253c5aeb.jpg";